"use client";

import { useState } from "react";
import AnimatedText from "./AnimatedText";
import translations from "@/lib/translations";
import Squircle from "./Squircle";

export default function ContactForm({ lang }) {
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		const formData = new FormData(e.target);
		const res = await fetch("/api/contact", {
			method: "POST",
			body: formData,
		});

		if (res.ok) {
			e.target.reset();
			setSuccess(true);
		}

		setLoading(false);
	};

	return (
		<form method="POST" className="form" onSubmit={handleSubmit}>
			<div className="group">
				<div className="field">
					<input id="prenom" type="text" name="prenom" placeholder=" " required />
					<label htmlFor="prenom">{translations.contact.name[lang]}</label>
				</div>

				<div className="field">
					<input id="email" type="email" name="email" placeholder=" " required />
					<label htmlFor="email">{translations.contact.email[lang]}</label>
				</div>
			</div>
			<div className="field">
				<textarea id="message" name="message" placeholder=" " required></textarea>
				<label htmlFor="message">{translations.contact.message[lang]}</label>
			</div>
			<div className="field checkbox">
				<label htmlFor="rgpd">
					<input id="rgpd" type="checkbox" name="rgpd" required />
					<span>{translations.contact.rgpd[lang]}</span>
				</label>
			</div>
			<div className="button align-center">
				<div className="button-container">
					<button type="submit" className="btn" disabled={loading}>
						{loading ? "Envoi…" : "Envoyer"}
					</button>
					<Squircle size="button"></Squircle>
				</div>
			</div>
			{success && (
				<div className="form-success" aria-live="polite">
					<AnimatedText variant="bounce">
						<h2>{translations.contact.messageSuccess1[lang]}</h2>
					</AnimatedText>
					<AnimatedText variant="bounce">
						<p>{translations.contact.messageSuccess2[lang]}</p>
					</AnimatedText>
				</div>
			)}
		</form>
	);
}
